import { render, staticRenderFns } from "./ClassicDimensionBoostRow.vue?vue&type=template&id=1e8534ec&"
import script from "./ClassicDimensionBoostRow.vue?vue&type=script&lang=js&"
export * from "./ClassicDimensionBoostRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports